import React from "react";
import Parser from "html-react-parser";
import PropTypes from "prop-types";
import { animations } from "react-animation";
import Image from "react-bootstrap/Image";
import DownloadSection from "@components/DonwloadSection/DownloadSection";
import "./TextTitleWithDownloads.css";

TextTitleWithDownloads.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  mainImage: PropTypes.string,
  titleLinks: PropTypes.string,
  downloadSections: PropTypes.array,
  borderTopColor: PropTypes.string,
};

function TextTitleWithDownloads({
  title,
  subtitle,
  text,
  mainImage,
  titleLinks = "Descargas",
  downloadSections,
  borderTopColor = "#001a70",
  ...props
}) {
  return (
    <div style={{ animation: animations.fadeIn }}>
      {subtitle ? (
        <>
          <div className="titulo_tt">{Parser(title)}</div>
          <div className="subtitulo_tt">{Parser(subtitle)}</div>
        </>
      ) : (
        <h1 className="titulo_tt_h1">{Parser(title)}</h1>
      )}
      <div
        className="text_tt"
        style={{ borderTop: "3px solid " + borderTopColor }}
      >
        {Parser(text)}

        {mainImage && (
          <div className="d-flex flex-column justify-content-center">
            <Image src={mainImage} fluid rounded bsPrefix="img" />
          </div>
        )}

        {downloadSections && (
          <>
            {downloadSections.map((dlsection, index) => {
              return dlsection.archivo ? (
                <DownloadSection
                  title={dlsection.tituloEnlace}
                  key={index}
                  downloadLinks={dlsection.archivo.urls}
                />
              ) : (
                <DownloadSection
                  title={dlsection.titulo}
                  key={dlsection.titulo}
                  downloadLinks={dlsection.archivosDescargables.contentItems}
                />
              );
            })}
          </>
        )}
      </div>
    </div>
  );
}

export default TextTitleWithDownloads;
